export class Input {
  private held = new Set<string>();
  private pressedThisFrame = new Set<string>();
  private mouseDX = 0;
  private mouseDY = 0;
  private wheelDelta = 0;
  private pointerLocked = false;
  private suspended = false;
  public mouseButtons = { left: false, right: false };
  public pressedMouse = { left: false, right: false };

  constructor(private canvas: HTMLCanvasElement) {
    window.addEventListener('keydown', this.onKeyDown);
    window.addEventListener('keyup', this.onKeyUp);
    canvas.addEventListener('mousedown', this.onMouseDown);
    window.addEventListener('mouseup', this.onMouseUp);
    window.addEventListener('mousemove', this.onMouseMove);
    window.addEventListener('wheel', this.onWheel, { passive: true });
    document.addEventListener('pointerlockchange', this.onPointerLockChange);
    window.addEventListener('blur', () => this.held.clear());
  }

  suspend(v: boolean) { this.suspended = v; if (v) this.held.clear(); }

  requestPointerLock(): void {
    if (!this.pointerLocked) this.canvas.requestPointerLock();
  }

  exitPointerLock(): void {
    if (this.pointerLocked) document.exitPointerLock();
  }

  isLocked(): boolean { return this.pointerLocked; }

  isDown(key: string): boolean {
    if (this.suspended) return false;
    return this.held.has(key.toLowerCase());
  }

  consumePress(key: string): boolean {
    const k = key.toLowerCase();
    if (this.pressedThisFrame.has(k)) {
      this.pressedThisFrame.delete(k);
      return true;
    }
    return false;
  }

  consumeMouse(button: 'left' | 'right'): boolean {
    if (this.pressedMouse[button]) {
      this.pressedMouse[button] = false;
      return true;
    }
    return false;
  }

  mouseDelta(): { dx: number; dy: number } {
    const out = { dx: this.mouseDX, dy: this.mouseDY };
    this.mouseDX = 0;
    this.mouseDY = 0;
    return out;
  }

  wheelStep(): number {
    const w = this.wheelDelta;
    this.wheelDelta = 0;
    return w;
  }

  endFrame(): void {
    this.pressedThisFrame.clear();
    this.pressedMouse.left = false;
    this.pressedMouse.right = false;
  }

  private onKeyDown = (e: KeyboardEvent) => {
    if (this.suspended) return;
    const k = e.key.toLowerCase();
    if (!this.held.has(k)) this.pressedThisFrame.add(k);
    this.held.add(k);
  };
  private onKeyUp = (e: KeyboardEvent) => {
    this.held.delete(e.key.toLowerCase());
  };
  private onMouseDown = (e: MouseEvent) => {
    if (e.button === 0) { this.mouseButtons.left = true; this.pressedMouse.left = true; }
    if (e.button === 2) { this.mouseButtons.right = true; this.pressedMouse.right = true; e.preventDefault(); }
  };
  private onMouseUp = (e: MouseEvent) => {
    if (e.button === 0) this.mouseButtons.left = false;
    if (e.button === 2) this.mouseButtons.right = false;
  };
  private onMouseMove = (e: MouseEvent) => {
    if (this.pointerLocked) {
      this.mouseDX += e.movementX;
      this.mouseDY += e.movementY;
    }
  };
  private onWheel = (e: WheelEvent) => {
    this.wheelDelta += Math.sign(e.deltaY);
  };
  private onPointerLockChange = () => {
    this.pointerLocked = document.pointerLockElement === this.canvas;
  };
}
